import React, { useState } from 'react';
import { Button, Chip } from '@mui/material';
import cx from 'classnames';

import { usePatientInfo } from '../../../PatientInfoContext';

import EncounterCard from './EncounterCard/EncounterCard';

import './EachProjectedEpoch.scss';

const ENCOUNTERS_TO_SHOW = 2;

export default function EachProjectedEpoch({ epoch }) {
  const { currentStudy } = usePatientInfo();
  const [showMore, setShowMore] = useState(false);

  const { encounters, nextEpochs, epochName, rootEpoch, started } = epoch;

  const isPresentEpochs = currentStudy?.isPresentEpochs;
  const nextEpochsLength = nextEpochs?.length;

  return (
    <div className={cx('each-projected-epoch', { 'each-projected-epoch-started': started })}>
      <div className="each-projected-epoch-card">
        <div className="epoch-card-header">
          {isPresentEpochs && `${epochName} `}
          {started ? (
            <Chip size="small" label="Started Epoch" color="success" />
          ) : (
            <Chip size="small" label="Not Started Epoch" color="info" />
          )}
        </div>
        {encounters.map(function(encounter, index) {
          if (index > ENCOUNTERS_TO_SHOW - 1 && !showMore) {
            return null;
          }
          return <EncounterCard key={encounter.encounterId} encounter={encounter} />;
        })}
        {encounters.length > ENCOUNTERS_TO_SHOW && (
          <div className="epoch-card-footer">
            <div>{encounters.length - ENCOUNTERS_TO_SHOW} more encounter(s)</div>
            <Button variant="text" size="small" onClick={() => setShowMore(state => !state)}>
              {showMore ? 'Hide More' : 'Show More'}
            </Button>
          </div>
        )}
        {(nextEpochsLength > 0 || !rootEpoch) && (
          <div className={cx('epoch-card-arrow', { 'epoch-card-arrow-line-only': nextEpochsLength < 2 })}></div>
        )}
      </div>
      {!!nextEpochsLength && (
        <>
          <div className="next-projected-epochs">
            {nextEpochs.map(function(epoch) {
              return <EachProjectedEpoch key={epoch.epochId} epoch={epoch} />;
            })}
          </div>
        </>
      )}
    </div>
  );
}
